// extracted by mini-css-extract-plugin
export default {"page":"UploadImage_page__kYf29","tabs":"UploadImage_tabs__2fIkq","tab":"UploadImage_tab__oz7qt","tabActive":"UploadImage_tabActive__jlWSR"};